import { render, staticRenderFns } from "./RecentOffers.vue?vue&type=template&id=4ac27959&scoped=true"
import script from "./RecentOffers.vue?vue&type=script&lang=ts"
export * from "./RecentOffers.vue?vue&type=script&lang=ts"
import style0 from "./RecentOffers.vue?vue&type=style&index=0&id=4ac27959&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac27959",
  null
  
)

export default component.exports